export function renderPlaceholderValue(value, placeholder) {
  if (value) return value;
  return <em style={{ color: "#aaa" }}>{placeholder}</em>;
}
